import { CircularProgress, styled } from '@mui/material';

export type MultipleProgressProps = {
  successes: number;
  fails: number;
  small?: boolean;
};

const StyledBackgroundCircularProgress = styled(CircularProgress)(
  ({ theme }) => ({
    position: 'absolute',
    left: 0,
    top: 0,
  })
);

const StyledCircularProgress = styled(CircularProgress)(({ theme }) => ({
  color: 'var(--success-success-icon-primary-color)',
  display: 'block',
  svg: {
    strokeLinecap: 'round',
  },
}));

const Wrapper = styled('div')({
  position: 'relative',
});

const ValueWrapper = styled('div')({
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  textAlign: 'center',
});

const Value = styled('span')<{ small?: boolean; success?: boolean }>(
  ({ small, success }) => ({
    position: 'absolute',
    color: success
      ? 'var(--success-success-icon-primary-color)'
      : 'var(--error-error-icon-primary-color)',
    fontWeight: 500,
    fontSize: small ? 10 : 33.25,
    letterSpacing: -0.5,
    '& > small': {
      fontSize: '0.7em',
    },
  })
);

export const MultipleProgress = ({
  successes,
  fails,
  small,
}: MultipleProgressProps) => {
  const progressValue =
    successes > 0 ? Math.ceil((successes * 100) / (successes + fails)) : 0;

  const successToFailRatio = successes / (fails + successes);

  return (
    <Wrapper>
      <div>
        <StyledBackgroundCircularProgress
          variant="determinate"
          color="error"
          value={100}
          size={small ? 40 : 130}
          thickness={2}
        />
        <StyledCircularProgress
          variant="determinate"
          value={progressValue}
          color="success"
          size={small ? 40 : 130}
          thickness={2}
        />
      </div>
      <ValueWrapper>
        <Value small={small} success={successToFailRatio >= 0.7}>
          {progressValue}
          <small>%</small>
        </Value>
      </ValueWrapper>
    </Wrapper>
  );
};
